// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"baj_a","InstagramEmbed__mask":"baj_b bhb_bi bhb_bo bhb_vt"};